// ink-component
// @ts-nocheck
import React from 'react';
import styled from 'styled-components';
import { border, layout, position } from 'styled-system';

import getGlobalProps from '../../helpers/constants/global-props';

import { dividerTokens } from '../../tokens/components/Divider/tokens';

export interface DividerProps {
  /** Sets the color of the divider */
  weight?: 'regular' | 'strong';
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

const Border = styled.div`
  ${border}
  ${layout}
  ${position}
`;

const globalProps = getGlobalProps({});

/**
 * @purpose Draws a separator
 * @categories layout
 * @aka separator
 */
function Divider({ weight = 'regular', 'data-testid': dataTestId }: DividerProps) {
  const getStyleForWeight = weight => {
    if (weight === 'strong') {
      return `1px solid ${dividerTokens.BorderColorStrongDefault}`;
    }
    return `1px solid ${dividerTokens.BorderColorRegularDefault}`;
  };

  return (
    <Border
      data-testid={dataTestId}
      role="separator"
      position="relative"
      bottom="0.5px"
      width="100%"
      borderTop={getStyleForWeight(weight)}
      {...globalProps}
    />
  );
}

Divider.defaultProps = {
  weight: 'regular',
};

Divider.displayName = 'Divider';

export default Divider;
